import React, {useMemo} from "react";
import {NavLink, useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";

import objectPath from "object-path";

//helpers and components:
import {HasPermission, checkIsActive} from "../../../../_metronic/_helpers";
import {useHtmlClassService} from "../../_core/MetronicLayout";
import {QuickUserToggler} from "../extras/QuiclUserToggler";
import SettingsIcon from '@material-ui/icons/Settings';
const Topbar = () => {
    const uiService = useHtmlClassService();
    const location = useLocation();
    const {t} = useTranslation();

    const layoutProps = useMemo(() => {
        return {
            viewSearchDisplay: objectPath.get(uiService.config, "extras.search.display"),
            viewNotificationsDisplay: objectPath.get(uiService.config, "extras.notifications.display"),
            viewQuickActionsDisplay: objectPath.get(uiService.config, "extras.quick-actions.display"),
            viewCartDisplay: objectPath.get(uiService.config, "extras.cart.display"),
            viewQuickPanelDisplay: objectPath.get(uiService.config, "extras.quick-panel.display"),
            viewLanguagesDisplay: objectPath.get(uiService.config, "extras.languages.display"),
            viewUserDisplay: objectPath.get(uiService.config, "extras.user.display"),
        };
    }, [uiService]);

    const getMenuItemActive = url => {
        return checkIsActive(location, url) ? "menu-item-active" : "";
    };

    return (
        <div className="topbar d-none d-lg-flex">
            <div className="d-flex align-items-center mx-2">
                <HasPermission permissionsToCheck={["settings.viewMenuLink"]}>
                    <NavLink className="menu-link" to="/adminpanel">
                        <span
                            className={`menu-text admin_panel_navlink d-flex flex-no-wrap ${
                                getMenuItemActive("/adminpanel") ? "active_navlink" : ""
                            }`}
                        >
                            <SettingsIcon className={'mr-2'}/>
                            {t("HEADER.BUTTONTEXT.ADMINPANEL")}
                        </span>
                    </NavLink>
                </HasPermission>
            </div>

            {layoutProps.viewUserDisplay && <QuickUserToggler />}
        </div>
    );
};

export default Topbar;
